import React, { useEffect, useRef } from "react";
import Header from "./header/Header";
import { Outlet } from "react-router-dom";
import * as awsui from '@cloudscape-design/design-tokens/index.js';

export default function CommonLayout({ title = "" }) {
  const headerContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const headerEl = headerContainerRef.current;
    if (!headerEl) {
      return;
    }

    let rafId: number | null = null;

    const applyMaxHeight = () => {
      const mainEl = document.querySelector(
        "main[class^='awsui_layout_']"
      ) as HTMLElement | null;

      const navContainerEl = document.querySelector(
        "div[class^='awsui_navigation-container_']"
      ) as HTMLElement | null;

      const navContentEl = document.querySelector(
        "div[class^='awsui_navigation-container_'] > nav[class^='awsui_navigation_']"
      ) as HTMLElement | null;

      const navShowEl = document.querySelector(
        "nav[class^='awsui_show-navigation_']"
      ) as HTMLElement | null;

      const drawersContainerEl = document.querySelector(
        "div[class^='awsui_drawers-container_']"
      ) as HTMLElement | null;
      
      const headerRect = headerEl.getBoundingClientRect();
      const headerHeightPx = Math.floor(headerRect.height);

      if (!mainEl) {
        return;
      }

      mainEl.style.setProperty(
        "min-block-size",
        `calc(100vh - ${headerHeightPx}px)`,
        "important"
      );
      if (navContainerEl) {
        navContainerEl.style.setProperty(
          "max-block-size",
          `100vh`,
          "important"
        );
        navContainerEl.style.setProperty(
          "block-size",
          `100%`,
          "important"
        );
        navContentEl.style.setProperty(
          "max-block-size",
          `calc(100vh - ${headerHeightPx}px)`,
          "important"
        );
        if (navShowEl && navShowEl.attributes.getNamedItem("aria-hidden")?.value === "true") {
          navContainerEl.style.setProperty(
            "border-inline-end",
            `1px solid ${awsui.colorBorderDividerDefault}`,
            "important"
          );
        } else {
            navContainerEl.style.setProperty(
            "border-inline-end",
            "unset",
            "important"
          );
        }
        navContentEl.style.setProperty(
          "border-inline-end",
          "unset",
          "important"
        );
      }
      if (drawersContainerEl) {
        drawersContainerEl.style.setProperty(
          "max-block-size",
          `100vh`,
          "important"
        );
        drawersContainerEl.style.setProperty(
          "block-size",
          `100%`,
          "important"
        );
      }
    };

    const handleResize = () => {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(applyMaxHeight);
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(headerEl);

    window.addEventListener("resize", handleResize);

    // In case the target main element mounts later, observe DOM mutations briefly
    const mutationObserver = new MutationObserver(applyMaxHeight);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    // Initial calculation
    handleResize();

    return () => {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
      }
      resizeObserver.disconnect();
      window.removeEventListener("resize", handleResize);
      mutationObserver.disconnect();
    };
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <div ref={headerContainerRef}>
          <Header title={title} />
        </div>
        <Outlet />
      </div>
    </>
  );
}
